import { type TLocaleContextValue, toLanguageCode } from '@frontends/util-i18n';
import { getEntityConfig } from '../../hooks/useEntityConfig';

export const replaceLanguageInUrl = (url: string, localeContext: TLocaleContextValue): string => {
  const config = getEntityConfig();
  const enabled = config.VITE_CLIENT_PORTAL_SUPPORTED_LOCALES.includes(localeContext.locale.language);
  const languageForClientPortal = enabled ? toLanguageCode(localeContext.locale.language) : 'en';

  return url.replace('/en/', `/${languageForClientPortal}/`);
};
